import type { Segment, SegmentsClientInterface } from './segmentsClient.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';

export default class OrgUnitSegmentsClient extends BaseClient implements SegmentsClientInterface {
    constructor(private teamId: number, private orgUnitId: number) {
        super();
    }

    getSegments(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSegmentsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createSegment(segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments`;
        return this.makeCoreApiRequest(url, 'post', segment);
    }

    getSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateSegment(segmentId: number, segment: Segment) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'put', segment);
    }

    deleteSegment(segmentId: number) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments/${segmentId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getSegmentsContactsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/segments/contact-counts`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}
